module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-square-f96dbb70.svg";